const ADMIN_ROLES = new Set(["admin", "super_admin"]);

export function getUserRoles(user) {
  if (!user) return [];

  const roles = Array.isArray(user.roles) ? [...user.roles] : [];
  if (user.role) roles.push(user.role);

  return [...new Set(roles.map((role) => String(role || "").trim().toLowerCase()).filter(Boolean))];
}

export function isAdminUser(user) {
  return Boolean(user?.is_admin || getUserRoles(user).some((role) => ADMIN_ROLES.has(role)));
}

export function hasUserRole(user, role) {
  return isAdminUser(user) || getUserRoles(user).includes(role);
}
